import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=116da5c3&scoped=true&"
import script from "./OurTeam.vue?vue&type=script&lang=js&"
export * from "./OurTeam.vue?vue&type=script&lang=js&"
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=116da5c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116da5c3",
  null
  
)

export default component.exports